module.exports = "<div class=\"environmentMenu\">\n    <div class=\"header\">\n        <div class=\"text\" *ngFor=\"let title of titles\"\n            [ngClass]=\"{ selected: title.state == $state.params.index }\"\n            (click)=\"$state.go('app.authorized.environment.' + title.state)\">\n            {{title.name}}\n        </div>\n    </div>\n    <hr>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/environmentDetails/environment-menu/environment-menu.component.html
// module id = 1743
// module chunks = 0